import { css, html } from 'lit';
import { customElement , state } from 'lit/decorators.js';
import { styleMap } from 'lit/directives/style-map.js';
import { toastSelector } from '../../redux/toasts/selectors.ts';
import type { Toast } from '../../redux/toasts/types.ts';
import type { ReduxState } from '../../redux/types.ts';
import { normalizeToRGBAString } from '../../utils/color/normalizeToRGBAString.ts';
import { ConnectedLitElement } from '../ConnectedLitElement.ts';
import { commonStyles } from '../styles/commonStyles.ts';


// Should match the transition time(s) of <toasts-container>
export const TOAST_FADE_IN_DURATION = .33;
export const TOAST_FADE_OUT_DURATION = .33;

@customElement('toasts-container')
export class ToastsContainer extends ConnectedLitElement {
  @state()
  toasts: Toast[] = [];

  render() {
    return this.toasts.map(({ message, state, color }) => html`
      <toast-banner class=${state} style=${styleMap({ background: normalizeToRGBAString(color) })}>
        <b>
          ${message}
        </b>
      </toast-banner>
    `);
  }

  stateChanged(state: ReduxState) {
    this.toasts = toastSelector(state);
  }

  static styles = [
    commonStyles,
    css`
      :host {
        position: fixed;
        display: flex;
        flex-direction: column-reverse;
        bottom: 8px;
        right: 0;
        top: 0;
        left: 0;
        z-index: 9999;
        align-items: flex-end;
        pointer-events: none;
      }

      toast-banner {
        position: relative;
        text-align: center;
        width: 100%;
        padding: 12px 16px;
        margin: 8px 16px;
        max-width: 360px;
        opacity: 0;
        color: #FFFFFF;
        background: #333;
        font-size: 13px;
        border-radius: 5px;
        box-shadow: 0 8px 16px rgba(49,60,67,.24);
        transition: .33s opactiy;
      }
      
      toast-banner.static {
        opacity: 1;
      }
    `
  ].flat();
}